module.exports = __webpack_public_path__ + "img/step1.77de0603.png";